<template>
  <div class="drawer">
    <MenuMember v-if="auth.loggedin" :items="menu.member" :profile="profile" />

    <MenuGuest v-else :items="menu.guest" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import MenuMember from './menu/MenuMember';
import MenuGuest from './menu/MenuGuest';
import data from './';

export default {
  name: 'the-drawer',

  components: {
    MenuMember,
    MenuGuest,
  },

  data() {
    return {
      ...data,
    };
  },

  computed: {
    ...mapState(['auth']),

    ...mapState({
      profile: ({ userProfile: { image, user_name, points, expert_role, user_level, first_name, last_name } }) => ({
        image,
        user_name,
        points,
        expert_role,
        user_level,
        first_name,
        last_name,
      }),
    }),
  },
};
</script>

<style lang="scss" scoped>
@import 'drawer';
</style>
